"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAwesomeSlider = _interopRequireDefault(require("react-awesome-slider"));

var _scaleOutAnimation = _interopRequireDefault(require("react-awesome-slider/src/styled/scale-out-animation"));

var _utils = require("../../utils");

var _SideBar = _interopRequireDefault(require("../SideBar"));

require("./style.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Story component.
 */
var Story = function Story(props) {
  var _props$active = props.active,
      active = _props$active === void 0 ? 0 : _props$active,
      children = props.children,
      image = props.image,
      description = props.description,
      label = props.label,
      logo = props.logo,
      type = props.type,
      onChange = props.onChange;

  var _useState = (0, _react.useState)(active),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var classes = (0, _utils.classList)('story-story', "story-story-".concat(type));
  var momentClass = "story-story__moments__moment-container";

  var moments = _react.default.Children.map(children, function (moment, index) {
    return _react.default.createElement("div", {
      index: index,
      className: momentClass,
      key: "moment-".concat(index)
    }, moment);
  });

  var handleMomentChange = function handleMomentChange(index) {
    onChange && onChange(index);
    setActiveIndex(index);
  };

  return _react.default.createElement("div", {
    className: classes
  }, _react.default.createElement(_SideBar.default, {
    activeIndex: activeIndex,
    onSelect: handleMomentChange,
    title: label,
    logo: logo,
    image: image,
    description: description
  }, children), _react.default.createElement("div", {
    className: "story-story__moments"
  }, _react.default.createElement(_reactAwesomeSlider.default, {
    bullets: false,
    organicArrows: false,
    buttons: false,
    selected: activeIndex
  }, moments)));
};

Story.propTypes = {
  /** Alternative labels of the `Story`*/
  alt_labels: _propTypes.default.arrayOf(_propTypes.default.string),

  /** The main description of the `Story` */
  description: _propTypes.default.string,

  /** Identifier of the `Story` */
  id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /** Image URL source */
  image: _propTypes.default.string,

  /** Main name of the `Story` */
  label: _propTypes.default.string.isRequired,

  /** List of `Moment`s to render of the `Story` */
  children: _propTypes.default.arrayOf(_propTypes.default.element).isRequired,

  /** Specify the type of `Story` */
  type: _propTypes.default.string
};
Story.defaultProps = {
  type: 'base',
  active: 0
};
var _default = Story;
exports.default = _default;